(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('DOMContentLoaded', function () {
      const sections = document.querySelectorAll('.timeline[data-section-id]');

      sections.forEach(function (section) {
        const blockCount = parseInt(section.dataset.blockCount, 10);
        const autoScroll = section.dataset.autoScroll === 'true';
        const autoInterval = parseInt(section.dataset.autoScrollInterval, 10);
        const dynamicWidths = section.dataset.dynamicWidths === 'true';
        const desktopHeroFraction = parseFloat(section.dataset.desktopHeroFraction) || 0;
        const mobileHeroFraction = parseFloat(section.dataset.mobileHeroFraction) || 0;
        const desktopGapFraction = parseFloat(section.dataset.desktopGapFraction) || 0;
        const mobileGapFraction = parseFloat(section.dataset.mobileGapFraction) || 0;

        const wrapper = section.querySelector('.timeline__image-wrapper');
        const image = section.querySelector('.timeline__image');
        const panels = section.querySelectorAll('.timeline__content-panel');
        const points = section.querySelectorAll('.timeline__bar-point');
        const progress = section.querySelector('.timeline__bar-progress');
        const btnsPrev = section.querySelectorAll('.timeline__nav-btn--prev');
        const btnsNext = section.querySelectorAll('.timeline__nav-btn--next');

        if (!image || !wrapper) return;

        let activeIndex = 0;
        let currentTranslateX = 0;
        let autoScrollTimer = null;

        // ── BREAKPOINT CHECK ──
        const mobileBreakpoint = window.matchMedia('(max-width: 768px)');

        function isMobile() {
          return mobileBreakpoint.matches;
        }

        // ── EXCESS WIDTH ──
        function getExcessWidth() {
          return image.offsetWidth - wrapper.offsetWidth;
        }

        // ── TRANSLATION VALUE FOR BLOCK (legacy, manual %) ──
        function getTranslationForBlock(index) {
          const point = points[index];
          if (isMobile()) {
            return parseInt(point.dataset.mobileTranslation, 10);
          }
          return parseInt(point.dataset.translation, 10);
        }

        // ── HERO FRACTION FOR CURRENT BREAKPOINT ──
        function getHeroFraction() {
          return isMobile() ? mobileHeroFraction : desktopHeroFraction;
        }

        // ── GAP FRACTION FOR CURRENT BREAKPOINT ──
        function getGapFraction() {
          return isMobile() ? mobileGapFraction : desktopGapFraction;
        }

        // ── HERO REST STATE ──
        // On mobile (dynamic mode) the hero is an initial resting state at
        // index -1, shown before the first block.
        function heroRestEnabled() {
          return dynamicWidths && isMobile();
        }

        // ── TRANSLATE X FOR BLOCK ──
        // Dynamic mode: derive the block width from the image width and the
        // number of blocks — (imageWidth - hero) / blockCount. This rescales
        // automatically as blocks are added/removed and is viewport-independent.
        //
        // Desktop: the copy panel sits on the LEFT, so each block is offset by
        // the hero width to land just right of the panel. There is no
        // right-edge clamp — later blocks intentionally scroll past the image's
        // right edge (the strip beyond shows the component background, replacing
        // the blank padding that used to be baked into the asset).
        //
        // Mobile: point 1 rests on the hero (image left edge, overflowing the
        // viewport). Each subsequent point LEFT-ALIGNS the next slide to the
        // viewport's left edge. The slides share the width after the hero, so
        // this scales with the number of points — the image should hold
        // (blockCount - 1) slides after the hero (e.g. 9 points = hero + 8).
        //
        // Legacy mode: use the per-block translation percentage.
        function getTranslateXForBlock(index) {
          if (dynamicWidths) {
            const imageW = image.offsetWidth;
            const heroW = getHeroFraction() * imageW;
            const gapW = getGapFraction() * imageW;
            // (blockCount - 1) gaps sit between the blocks (none before the
            // first block or after the last), so remove that total from the
            // usable width before splitting it evenly.
            const gapsTotal = gapW * (blockCount - 1);

            if (isMobile()) {
              // The hero is an initial rest (index -1) at the image's left
              // edge, overflowing the viewport. Each block then LEFT-ALIGNS to
              // the viewport: block 0 (block 1) at the hero's right edge, and
              // so on. With N blocks that's N stops after the hero, so every
              // block — including the last — is reachable.
              if (index < 0) return 0;
              const blockW = (imageW - heroW - gapsTotal) / blockCount;
              const step = blockW + gapW;
              return -(heroW + index * step);
            }

            // Desktop: the client's assets also carry a trailing pad on the
            // right matching the hero width on the left, so it's excluded
            // from the divisible block width the same way the hero is —
            // only the left hero offsets the scroll position, the trailing
            // pad is just never divided into a block.
            const blockW = (imageW - heroW * 2 - gapsTotal) / blockCount;
            const step = blockW + gapW;
            return -(index * step);
          }
          return -(getTranslationForBlock(index) / 100) * getExcessWidth();
        }

        // ── APPLY TRANSLATE ──
        function applyTranslate(x, animate) {
          if (animate) {
            image.classList.remove('no-transition');
          } else {
            image.classList.add('no-transition');
          }
          image.style.transform = 'translateX(' + x + 'px)';
          currentTranslateX = x;
        }

        // ── NEAREST BLOCK ──
        function getNearestBlock(translateX) {
          const lo = heroRestEnabled() ? -1 : 0; // -1 = hero rest
          let closest = lo;
          let closestDist = Infinity;
          for (let i = lo; i < blockCount; i++) {
            const dist = Math.abs(translateX - getTranslateXForBlock(i));
            if (dist < closestDist) {
              closestDist = dist;
              closest = i;
            }
          }
          return closest;
        }

        // ── SET ACTIVE ──
        function setActive(index) {
          activeIndex = index;

          // At the hero rest (index -1) show the first block's copy card so its
          // nav arrows remain available; no timeline dot is active there.
          const panelIndex = Math.max(0, index);
          panels.forEach(function (panel, i) {
            panel.classList.toggle('timeline__content-panel--active', i === panelIndex);
          });

          points.forEach(function (point, i) {
            point.classList.toggle('timeline__bar-point--active', i === index);
          });

          const pct = blockCount > 1 ? (Math.max(0, index) / (blockCount - 1)) * 100 : 0;
          progress.style.width = pct + '%';

          const lo = heroRestEnabled() ? -1 : 0;
          btnsPrev.forEach(function (btn) {
            btn.disabled = index <= lo;
          });
          btnsNext.forEach(function (btn) {
            btn.disabled = index === blockCount - 1;
          });

          if (points[index]) {
            points[index].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
          }
        }

        // ── GO TO BLOCK ──
        function goToBlock(index) {
          const lo = heroRestEnabled() ? -1 : 0; // -1 = hero rest
          if (index < lo || index >= blockCount) return;
          setActive(index);
          applyTranslate(getTranslateXForBlock(index), true);
        }

        // ── STEP TO ADJACENT BLOCK ──
        // Block 0's copy is already shown during the hero rest (-1), so
        // sequential stepping treats -1 and 0 as the same "item 1" stop —
        // otherwise the first press of next/prev lands on 0 with no visible
        // change, since the copy panel doesn't move.
        function stepIndex(from, delta) {
          // The -1/0 skip only makes sense where the hero rest exists
          // (mobile). On desktop, index 0 is a normal, reachable stop.
          if (heroRestEnabled()) {
            if (delta > 0 && from === -1) return 1;
            if (delta < 0 && from === 1) return -1;
          }
          return from + delta;
        }

        // ── AUTO SCROLL ──
        // Stops any existing timer, then starts a fresh one if auto scroll
        // is enabled. Each tick advances to the next slide, wrapping back
        // to 0 after the last. Calling stopAutoScroll() before goToBlock()
        // inside the tick prevents timer stacking.
        function stopAutoScroll() {
          if (autoScrollTimer) {
            clearInterval(autoScrollTimer);
            autoScrollTimer = null;
          }
        }

        function startAutoScroll() {
          if (!autoScroll || blockCount <= 1) return;
          stopAutoScroll(); // always clear before starting to avoid stacking
          autoScrollTimer = setInterval(function () {
            const next = activeIndex < blockCount - 1 ? stepIndex(activeIndex, 1) : (heroRestEnabled() ? -1 : 0);
            goToBlock(next);
          }, autoInterval);
        }

        // ── USER INTERACTION ──
        // Any deliberate user action (nav buttons, point clicks, drag)
        // permanently stops the auto scroll for this page session.
        function onUserInteraction() {
          stopAutoScroll();
        }

        // ── DRAG LOGIC ──
        let isDragging = false;
        let dragStartX = 0;
        let dragStartTranslate = 0;
        let touchStartY = 0;
        let touchDirection = null;

        function onDragStart(startX) {
          isDragging = true;
          dragStartX = startX;
          dragStartTranslate = currentTranslateX;
          wrapper.classList.add('is-dragging');
          applyTranslate(currentTranslateX, false);
        }

        function onDragMove(currentX) {
          if (!isDragging) return;
          const delta = currentX - dragStartX;
          // In dynamic mode the last block sits past the image's right edge,
          // so allow dragging that far; otherwise stop at the right edge.
          const minX = dynamicWidths ? getTranslateXForBlock(blockCount - 1) : -getExcessWidth();
          const maxX = 0;
          const newX = Math.min(maxX, Math.max(minX, dragStartTranslate + delta));
          applyTranslate(newX, false);
        }

        function onDragEnd() {
          if (!isDragging) return;
          isDragging = false;
          wrapper.classList.remove('is-dragging');

          const dragDelta = Math.abs(currentTranslateX - dragStartTranslate);

          if (dragDelta > 20) {
            onUserInteraction();
            const nearest = getNearestBlock(currentTranslateX);
            goToBlock(nearest);
          } else {
            applyTranslate(getTranslateXForBlock(activeIndex), true);
          }
        }

        // ── MOUSE DRAG ──
        wrapper.addEventListener('mousedown', function (e) {
          onDragStart(e.clientX);
        });

        window.addEventListener('mousemove', function (e) {
          onDragMove(e.clientX);
        });

        window.addEventListener('mouseup', function () {
          onDragEnd();
        });

        // ── TOUCH DRAG ──
        wrapper.addEventListener(
          'touchstart',
          function (e) {
            touchDirection = null;
            touchStartY = e.touches[0].clientY;
            onDragStart(e.touches[0].clientX);
          },
          { passive: true }
        );

        wrapper.addEventListener(
          'touchmove',
          function (e) {
            if (!isDragging) return;

            if (!touchDirection) {
              const dx = Math.abs(e.touches[0].clientX - dragStartX);
              const dy = Math.abs(e.touches[0].clientY - touchStartY);
              if (dx > 5 || dy > 5) {
                touchDirection = dx >= dy ? 'horizontal' : 'vertical';
              }
            }

            if (touchDirection === 'vertical') {
              isDragging = false;
              wrapper.classList.remove('is-dragging');
              return;
            }

            onDragMove(e.touches[0].clientX);
            if (touchDirection === 'horizontal') {
              e.preventDefault();
            }
          },
          { passive: false }
        );

        wrapper.addEventListener('touchend', function () {
          onDragEnd();
        });

        // ── NAV BUTTONS ──
        btnsPrev.forEach(function (btn) {
          btn.addEventListener('click', function () {
            onUserInteraction();
            goToBlock(stepIndex(activeIndex, -1));
          });
        });

        btnsNext.forEach(function (btn) {
          btn.addEventListener('click', function () {
            onUserInteraction();
            goToBlock(stepIndex(activeIndex, 1));
          });
        });

        // ── TIMELINE POINTS ──
        points.forEach(function (point) {
          point.addEventListener('click', function () {
            onUserInteraction();
            goToBlock(parseInt(point.dataset.index, 10));
          });
        });

        // ── RESIZE ──
        window.addEventListener('resize', function () {
          applyTranslate(getTranslateXForBlock(activeIndex), false);
        });

        // ── INIT ──
        const startIndex = heroRestEnabled() ? -1 : 0; // rest on the hero on mobile
        applyTranslate(getTranslateXForBlock(startIndex), false);
        setActive(startIndex);
        startAutoScroll();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
